import { render, staticRenderFns } from "./passing-search-list.vue?vue&type=template&id=2f5a4b86&scoped=true"
import script from "./passing-search-list.vue?vue&type=script&lang=js"
export * from "./passing-search-list.vue?vue&type=script&lang=js"
import style0 from "./passing-search-list.vue?vue&type=style&index=0&id=2f5a4b86&prod&scoped=true&lang=scss"
import style1 from "./passing-search-list.vue?vue&type=style&index=1&id=2f5a4b86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a4b86",
  null
  
)

export default component.exports